document.addEventListener('DOMContentLoaded', function() {
    const thumbs = document.querySelectorAll('.methodology__thumb.has-video');

    thumbs.forEach(thumb => {
        const videoId = thumb.dataset.videoId;
        const iframeContainer = thumb.querySelector('.iframe');
        const playButton = thumb.querySelector('.play');

        if (!videoId || !iframeContainer || !playButton) return;

        thumb.addEventListener('click', function() {
            const iframe = document.createElement('iframe');
            iframe.classList.add('video-yt');
            iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1';
            iframe.title = 'Vídeo Colégio Joseense';
            iframe.frameBorder = '0';
            iframe.allow = 'autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            iframe.referrerPolicy = 'strict-origin-when-cross-origin';
            iframe.allowFullscreen = true;

            iframeContainer.style.display = 'block';
            iframeContainer.appendChild(iframe);

            playButton.style.display = 'none';
            thumb.style.cursor = 'default';
            thumb.classList.add('video-playing');

            const section = thumb.closest('.methodology');
            if (section) section.classList.add('video-playing');
        });
    });
});